import React from 'react'
import { useTranslation } from 'react-i18next'
import { IconButton } from '@fs/zion-ui'
import { NoticeInfo } from '@fs/zion-icon'

const RecordTooltipButton = ({ overlay, stepText }) => {
  const [t] = useTranslation()
  return (
    <IconButton
      title={t('family-review.record-tool-tip.title', 'What is a record?')}
      size="sm"
      Icon={NoticeInfo}
      linkName={`Family Review Step ${stepText} Record Tooltip Button`}
      onClick={overlay.handleClick}
      data-testid="record-tooltip-button"
    />
  )
}

export default RecordTooltipButton
